import { render } from "./CSVMangelliste.vue?vue&type=template&id=c39caa78&scoped=true&ts=true"
import script from "./CSVMangelliste.vue?vue&type=script&lang=ts"
export * from "./CSVMangelliste.vue?vue&type=script&lang=ts"

import "./CSVMangelliste.vue?vue&type=style&index=0&id=c39caa78&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39caa78"]])

export default __exports__